var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box1"},[_c('div',{staticClass:"sq_box"},[_c('img',{attrs:{"src":require("../../../assets/images/7.png")}}),_c('div',{staticClass:"sq_con"},[_c('div',[_c('div',{on:{"click":function($event){return _vm.goApply(1)}}},[_vm._v("个人会员")]),_c('div',{on:{"click":function($event){return _vm.goApply(2)}}},[_vm._v("企业会员")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }